import React from 'react';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import LoadingSpinner from '../loading-spinner';
import styles from './style.module.scss';

interface Props {
  className?: string;
  showSpinner?: boolean;
  showText?: boolean;
}

export default function LoadingText({ 
  className = '', 
  showSpinner = false,
  showText = true,  
}: Props) {
  const { t } = useTranslation(Namespaces.COMMON);
  
  if (showSpinner && showText) {
    return (
      <div className={`${styles.component} ${className}`}>
        <LoadingSpinner />
        <span className={styles.text}>{t(LOCALE_COMMON_PATHS.LOADING)}</span>
      </div>
    );
  }
  
  if (showSpinner) {
    return <LoadingSpinner className={className} />;
  }
  
  if (showText) {
    return <div className={className}>{t(LOCALE_COMMON_PATHS.LOADING)}</div>;
  }
  
  return null;
}
